import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUndo(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#undo_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#undo_svg__b)" strokeWidth={20} />
      </g>
      <path
        fill="#0C1C43"
        d="M80.942 67.308a.625.625 0 0 1-.884.884l-3.674-3.674a2.5 2.5 0 0 1 0-3.536l3.674-3.674a.625.625 0 0 1 .884.884l-3.674 3.674q-.12.12-.2.259h16.87a5.313 5.313 0 0 0 0-10.625H88a.625.625 0 1 1 0-1.25h5.938a6.562 6.562 0 1 1 0 13.125h-16.87q.08.14.2.259z"
      />
      <defs>
        <linearGradient
          id="undo_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="undo_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUndo);
export default ForwardRef;
